import React, { useState, useEffect } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import InputComponent from "../partner/components/inputComponent";
import InputSelect from "../partner/components/inputSelect";
import { CircularProgress, TextField } from "@material-ui/core";
import InputDecimalInventory from "./components/inputDecimal";
import InputDisableSimpleText from "../user/components/inputDisableSimpleText";
import Modal from "../modals/Modal";
import ModalMessage from "../modals/ModalMessage";
import InputSelectTypeOfOutput from "./components/inputSelectTypeOfOutput";
import * as Icons from "@material-ui/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import config from "../../config";

// styles
import useStyles from "./styles";
import useStylesTable from "./styles";

export default function ProductOutlet() {
  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    address: /^[a-zA-Z0-9#, ]{4,500}$/, // Address
  }

  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [productName, setProductName] = useState({ text: '', valid: null });
  const [barcode, setBarcode] = useState({ text: '', valid: null });
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState({ text: '', valid: null });
  const [image, setImage] = useState({ text: '', valid: null });
  const [cost, setCost] = useState({ text: 0.00, valid: null });
  const [profitCost, setProfitCost] = useState({ text: 0.00, valid: null });
  const [priceProduct, setPriceProduct] = useState({ text: 0.00, valid: null });
  const [saleUnit, setSaleUnit] = useState({ text: '', valid: null });
  const [stock, setStock] = useState({ text: '', valid: null });
  const [minStock, setMinStock] = useState({ text: '', valid: null });
  const [note, setNote] = useState('');
  const [entryType, setEntryType] = useState({ text: '', valid: null });
  const [products, setProducts] = useState([]);
  const [indexTemporal, setIndexTemporal] = useState(1);

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [keyTable, setKeyTable] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [isProductExist, setIsProductExist] = useState(false);
  const [editIndex, setEditIndex] = useState(0);

  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({
    id: '', name: '', barcode: '', image: '', cost: 0.00, description: '',
    category: '', isProfitByPercent: 0, profitProduct: '', salePrice: '', saleUnit: '', stock: '', minStock: '',
    note: ''
  });

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const closeModalMessage = e => {
    setShowModalMessage(false);
  }

  const fechGetProducts = async () => {
    fetch(baseUrl + "products",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else {
          setAllProducts(data);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fechGetProducts();
  }, []);

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    var product = {
      "id": isEdit ? editIndex : indexTemporal,
      "name": productName.text,
      "barcode": barcode.text,
      "description": description,
      "catrgory": category.text,
      "image": image.text,
      "cost": cost.text,
      "productProfit": profitCost.text,
      "salePrice": priceProduct.text,
      "saleUnit": saleUnit.text,
      "stock": stock.text,
      "minStock": minStock.text,
      "note": note,
    };

    if (isEdit) {
      const allList = products;
      allList[editIndex] = product;
      setProducts(allList);
    } else {
      if (products.length > 0) {
        products.map((item) => {
          if (item.name == product.name) {
            setIsProductExist(true);
            setShowModalMessage(true);
          } else {
            setIndexTemporal(indexTemporal + 1);
            const allList = products;
            allList.push(product);
            setProducts(allList);
          }
        });
      } else {
        setIndexTemporal(indexTemporal + 1);
        const allList = products;
        allList.push(product);
        setProducts(allList);
      }
    }

    setProductName({ text: '', valid: 'false' });
    setBarcode({ text: '', valid: 'false' });
    setDescription('');
    setCategory({ text: '', valid: 'false' });
    setImage({ text: '', valid: 'false' });
    setCost({ text: 0.00, valid: 'false' });
    setProfitCost({ text: 0.00, valid: 'false' });
    setPriceProduct({ text: 0.00, valid: 'false' });
    setSaleUnit({ text: '', valid: 'false' });
    setStock({ text: '', valid: 'false' });
    setMinStock({ text: '', valid: 'false' });
    setNote('');

    setIsEdit(false);
    setEditIndex(0);
    setIsLoading(false);

    setKeyTable(keyTable + 1)
  }

  const onSave = async e => {
    e.preventDefault();
    setIsLoading(true);

    setIsLoading(false);
  }

  const calculatePrice = () => {
    if (cost.text != 0.00 && profitCost.text != 0.00) {
      setPriceProduct({
        text: (parseFloat(cost.text) + parseFloat(profitCost.text)).toFixed(2),
        valid: "true"
      });
    } else {
      setPriceProduct({
        text: 0.00,
        valid: "falsee"
      });
    }
  }

  const updateSelectedProduct = () => {
  }

  const onDelete = (property) => (event) => {
    var indexProduct = -1;

    products.map((item) => {
      if (item.id == property) {
        indexProduct = products.indexOf(item);
      }
    });

    if (indexProduct > -1) {
      var list = products;
      if (list.length == 1) {
        setProducts([]);
      } else {
        delete list[indexProduct];
        setProducts(list);
      }

      setKeyTable(keyTable + 1);
    }
  };

  const onEdit = (property) => (event) => {
    event.preventDefault();
    var indexProduct = 0;
    var product = null;

    products.map((item) => {
      if (item.id == property) {
        indexProduct = products.indexOf(item);
        product = item;
      }
    });

    if (product != null) {
      setIsEdit(true);
      setEditIndex(indexProduct);

      setProductName({ text: product.name, valid: 'true' });
      setBarcode({ text: product.barcode, valid: 'true' });
      setDescription(product.description);
      setCategory({ text: product.category, valid: 'true' });
      setImage({ text: product.image, valid: 'true' });
      setCost({ text: product.cost, valid: 'true' });
      setProfitCost({ text: product.productProfit, valid: 'true' });
      setPriceProduct({ text: product.salePrice, valid: 'true' });
      setSaleUnit({ text: product.saleUnit, valid: 'true' });
      setStock({ text: product.stock, valid: 'true' });
      setMinStock({ text: product.minStock, valid: 'true' });
      setNote(product.note);
    }
  }

  const onTagsChange = (event, values) => {
    if (values != null) {
      setProductName({ text: values.name, valid: 'true' });
      setBarcode({ text: values.barcode, valid: 'true' });
      setDescription(values.description);
      setCategory({ text: values.category, valid: 'true' });
      setImage({ text: values.image, valid: 'true' });
      setCost({ text: values.cost, valid: 'true' });
      setProfitCost({ text: values.productProfit, valid: 'true' });
      setPriceProduct({ text: values.salePrice, valid: 'true' });
      setSaleUnit({ text: values.saleUnit, valid: 'true' });
      setStock({ text: values.stock, valid: 'true' });
      setMinStock({ text: values.minStock, valid: 'true' });
      setNote(values.note);
    } else {
      setProductName({ text: '', valid: 'false' });
      setBarcode({ text: '', valid: 'false' });
      setDescription('');
      setCategory({ text: '', valid: 'false' });
      setImage({ text: '', valid: 'false' });
      setCost({ text: 0.00, valid: 'false' });
      setProfitCost({ text: 0.00, valid: 'false' });
      setPriceProduct({ text: 0.00, valid: 'false' });
      setSaleUnit({ text: '', valid: 'false' });
      setStock({ text: '', valid: 'false' });
      setMinStock({ text: '', valid: 'false' });
      setNote('');
    }
  }

  return (
    <>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      {isProductExist ? (
        <ModalMessage
          isOpen={showModalMessage}
          closeModal={closeModalMessage}
        />
      ) : (
        <></>
      )}

      <div className={classes.divTitle}>
        <PageTitle title="Salida de productos" />
      </div>

      <div>
        <label className={classes.titleStyle}>Selecciona una opción</label>
        <div style={{ width: "300px" }}>
          <InputSelectTypeOfOutput
            text={entryType}
            setValue={setEntryType}
            updateSelectedProduct={updateSelectedProduct}
          />
        </div>
        <br />
        <br />

        {entryType.text != "" ? (
          <div className={classes.divHeader} >
            <div className={classes.div} >
              <Autocomplete
                options={allProducts}
                freeSolo
                getOptionLabel={option => option.name}
                onChange={onTagsChange}
                openText={"Abrir"}
                closeText={"Cerrar"}
                clearText={"Limpiar"}
                noOptionsText={"Sin resultados"}
                renderInput={params => (
                  <TextField
                    {...params}
                    value={productName.text}
                    variant="standard"
                    placeholder={"Buscar producto"}
                    style={{
                      border: '0px',
                      backgroundColor: "#FFFFFF",
                      borderRadius: '100px',
                      marginLeft: '8px',
                      width: '350px',
                      outlineColor: "#FFFFFF",
                    }}
                  />
                )}
              />
              <div className={classes.divSearch} >
                <Icons.Search classes={{ root: classes.searchIconProduct }} />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>

      {entryType.text != "" ? (
        <div className={classes.divCard} >
          <div className={classes.divColumn}>
            {selectedProduct.image != '' || selectedProduct.image != null ? (
              <div style={{
                height: "200px", width: "310px", backgroundColor: "#e0e0e0"
              }}>
              </div>
            ) : (
              <img
                src={baseUrl + "userImage/" + image.text}
                alt=""
                height={200}
              />
            )}

            <div>
              <InputComponent
                text={productName}
                setPartnerCode={setProductName}
                type="text"
                label="Nombre del producto"
                name="productName"
                regularExpression={expressions.nombre}
                placeholder="Nombre"
                isEnable={true}
              />

              <InputComponent
                text={barcode}
                setPartnerCode={setBarcode}
                type="text"
                label="Código de barras"
                name="barcode"
                regularExpression={expressions.nombre}
                placeholder="Código de barras"
                isEnable={true}
              />

              <InputDecimalInventory
                text={cost}
                setPartnerCode={setCost}
                type="text"
                label="Costo"
                name="cost"
                placeholder="100.00"
                calculate={calculatePrice}
                isEnable={true}
              />

            </div>
          </div>
          <div className={classes.divThreeColumns} >
            <div>
              <div className={classes.divLabel}>
                <p>Descripción</p>
              </div>

              <p
                style={{
                  width: '85%', backgroundColor: "#000000",
                  color: "#FFFFFF", fontSize: "16px"
                }}
              >{description}</p>
            </div>

            <InputComponent
              text={category}
              setPartnerCode={setCategory}
              type="text"
              label="Categoría"
              name="category"
              placeholder="Categoría"
              isEnable={true}
            />

            <InputDecimalInventory
              text={profitCost}
              setPartnerCode={setProfitCost}
              type="text"
              label="Ganancia del producto"
              name="profitProduct"
              placeholder="100.00"
              calculate={calculatePrice}
            />

            <InputDisableSimpleText
              value={priceProduct.text}
              type="text"
              label="Precio de venta"
              name="priceProduct"
              placeholder="100.00"
              isPrice={true}
            />

            <InputComponent
              text={saleUnit}
              setPartnerCode={setSaleUnit}
              type="text"
              label="Unidad de venta"
              name="saleUnit"
              placeholder="Unidad de venta"
              isEnable={true}
            />

            <InputComponent
              text={stock}
              setPartnerCode={setStock}
              type="number"
              label="Stock / Cantidad"
              name="stock"
              regularExpression={expressions.numbers}
              placeholder="1"
            />

            <InputComponent
              text={minStock}
              setPartnerCode={setMinStock}
              type="number"
              label="Stock mínimo"
              name="minStock"
              regularExpression={expressions.numbers}
              placeholder="1"
            />

            <InputComponent
              text={note}
              setPartnerCode={setNote}
              type="text"
              label="Nota"
              name="note"
              regularExpression={expressions.nombre}
              placeholder="Nota corta"
            />
          </div>

          <div className={classes.divButton}>
            {isLoading ? (
              <div className={classes.loginLoader} >
                <CircularProgress size={26} />
              </div>
            ) : (
              <button
                className={productName.valid === 'true' && cost.valid === 'true' && profitCost.valid == 'true'
                  && stock.valid === 'true' ?
                  classes.enableButton : classes.disableButton}
                disabled={!(productName.valid === 'true' && cost.valid === 'true' && profitCost.valid == 'true'
                  && stock.valid === 'true')}
                onClick={onSubmit}
              >Agregar</button>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      {products.length > 0 ? (
        <>
          <div style={{ marginTop: "60px" }}></div>
          <div className={classesTable.divCard} >
            <Table className="mb-0" key={keyTable}>
              <TableHead>
                <TableRow className={classesTable.root} >
                  <TableCell>NOMBRE</TableCell>
                  <TableCell>COSTO</TableCell>
                  <TableCell>PRECIO DE VENTA</TableCell>
                  <TableCell>CANTIDAD</TableCell>
                  <TableCell>ACCIÓN</TableCell>
                  {/*{keys.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}*/}
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map(({ id, name, cost, salePrice, stock }) => (
                  <TableRow key={id}>
                    <TableCell className={classesTable.tableTextStyle} >{name}</TableCell>
                    <TableCell className={classesTable.tableTextStyle} >{"$ " + parseFloat(cost).toFixed(2)}</TableCell>
                    <TableCell className={classesTable.tableTextStyle} >{"$ " + parseFloat(salePrice).toFixed(2)}</TableCell>
                    <TableCell className={classesTable.tableTextStyle} >{stock}</TableCell>
                    <TableCell className={classesTable.tableTextStyle} >
                      <div style={{ display: "flex" }}>
                        <div className={classesTable.divActionButton}>
                          <Edit className={classesTable.iconAcctionInventory}
                            onClick={onEdit(id)}
                          />
                        </div>

                        <div className={classesTable.divActionButton}>
                          <Delete className={classesTable.iconAcctionInventory}
                            onClick={onDelete(id)}
                          />
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>

          <div className={classes.divButton}>
            {isLoading ? (
              <div className={classes.loginLoader} >
                <CircularProgress size={26} />
              </div>
            ) : (
              <button
                className={products.length > 0 ?
                  classes.enableButton : classes.disableButton}
                disabled={!(products.length > 0)}
                onClick={onSave}
              >GUARDAR</button>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
